import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Paper
} from '@mui/material';

export default function AuditDetailModal({ open, audit, onClose }) {
  if (!audit) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Dettaglio Audit</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Entity:</Typography>
            <Typography>{audit.entity}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Action:</Typography>
            <Typography>{audit.action}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Username:</Typography>
            <Typography>{audit.username}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Role:</Typography>
            <Typography>{audit.role}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Outcome:</Typography>
            <Typography>{audit.outcome}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Timestamp:</Typography>
            <Typography>{new Date(audit.timestamp).toLocaleString()}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Entity ID:</Typography>
            <Typography>{audit.entityId}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">IP:</Typography>
            <Typography>{audit.ip}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Method:</Typography>
            <Typography>{audit.method}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Payload:</Typography>
            <Paper variant="outlined" sx={{ p: 1, backgroundColor: '#f5f5f5', whiteSpace: 'pre-wrap', overflowX: 'auto' }}>
              {audit.payload || '-'}
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Response:</Typography>
            <Paper variant="outlined" sx={{ p: 1, backgroundColor: '#f5f5f5', whiteSpace: 'pre-wrap', overflowX: 'auto' }}>
              {audit.response || '-'}
            </Paper>
          </Grid>
          {audit.reason && (
            <Grid item xs={12}>
              <Typography variant="subtitle2">Reason (errore):</Typography>
              <Paper variant="outlined" sx={{ p: 1, backgroundColor: '#f5f5f5', whiteSpace: 'pre-wrap', overflowX: 'auto' }}>
                {audit.reason}
              </Paper>
            </Grid>
          )}
          <Grid item xs={12}>
            <Typography variant="subtitle2">User Agent:</Typography>
            <Typography>{audit.userAgent}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">Chiudi</Button>
      </DialogActions>
    </Dialog>
  );
}